var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "AppLayout",
    {
      attrs: {
        page: "/dashboard",
        pageTitle: "Past Due Invoices",
        backLink: "/dashboard/reports",
      },
    },
    [
      _c(
        "v-overlay",
        { attrs: { value: _vm.retryLoading, "z-index": "999" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "64" },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-col",
        { staticClass: "pa-1", attrs: { cols: "12" } },
        [
          _c(
            "v-card",
            { staticClass: "soli-round" },
            [
              _c(
                "v-container",
                { staticClass: "px-3", attrs: { fluid: "" } },
                [
                  _c("ReportHeader", {
                    attrs: {
                      filter: "",
                      subtitle: `${_vm.total} outstanding in ${_vm.clients} client(s)`,
                      dateRange: _vm.dateRange,
                      reportUrl: "/dashboard/reports/past-due-invoices",
                      dateOptions: "month, quarter, year, all",
                    },
                    on: {
                      search: function ($event) {
                        _vm.search = $event
                      },
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "extendedSubtitle",
                        fn: function () {
                          return [
                            _c(
                              "div",
                              [
                                _c(
                                  "v-btn",
                                  {
                                    staticClass: "soli-round soli-blue-text",
                                    attrs: { "x-small": "", outlined: "" },
                                    on: {
                                      click: function ($event) {
                                        _vm.$inertia.reload({
                                          data: {
                                            showUncollectible: Number(
                                              !_vm.showUncollectible
                                            ),
                                          },
                                        })
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.showUncollectible
                                          ? `Hide Uncollectible`
                                          : `Show Uncollectible`
                                      )
                                    ),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                      {
                        key: "filterItem",
                        fn: function () {
                          return [
                            _c(
                              "v-list",
                              { attrs: { dense: "" } },
                              [
                                _c(
                                  "v-list-item",
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          href: `${_vm.$page.url}${
                                            _vm.hasParams ? "&" : "?"
                                          }csv=true`,
                                          text: "",
                                          outlined: "",
                                          rounded: "",
                                          block: "",
                                          color: "dark",
                                        },
                                      },
                                      [
                                        _vm._v("Download as CSV"),
                                        _c(
                                          "v-icon",
                                          { attrs: { small: "", right: "" } },
                                          [_vm._v("download")]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                        proxy: true,
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  false
                    ? _c(
                        "v-list",
                        [
                          _c(
                            "v-list-item",
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "soli-subtitle" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          `${_vm.globalMomentMonthFull()} ${_vm.globalMomentYear()}`
                                        ) + "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-subtitle",
                                    {
                                      staticStyle: { "white-space": "normal" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          `Customers with past due invoices`
                                        ) + "\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-subtitle",
                                    {
                                      staticClass: "font-bold",
                                      staticStyle: { "white-space": "normal" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.total) +
                                          " outstanding in\n                                " +
                                          _vm._s(_vm.clients) +
                                          " client(s)\n                            "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-list-item-subtitle",
                                    {
                                      staticClass: "font-bold py-1",
                                      staticStyle: { "white-space": "normal" },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass:
                                            "soli-round soli-blue-text",
                                          attrs: {
                                            "x-small": "",
                                            outlined: "",
                                          },
                                          on: {
                                            click: function ($event) {
                                              _vm.$inertia.reload({
                                                data: {
                                                  showUncollectible: Number(
                                                    !_vm.showUncollectible
                                                  ),
                                                },
                                              })
                                            },
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.showUncollectible
                                                ? `Hide Uncollectible`
                                                : `Show Uncollectible`
                                            )
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-list-item-action",
                                [
                                  _c(
                                    "v-row",
                                    [
                                      _vm.$vuetify.breakpoint.xs
                                        ? _c(
                                            "v-menu",
                                            {
                                              attrs: {
                                                right: "",
                                                "close-on-content-click": false,
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function ({
                                                      on,
                                                      attrs,
                                                    }) {
                                                      return [
                                                        _c(
                                                          "v-btn",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                staticClass:
                                                                  "elevation-3 ml-1",
                                                                attrs: {
                                                                  small:
                                                                    _vm.$vuetify
                                                                      .breakpoint
                                                                      .xs,
                                                                  icon: "",
                                                                },
                                                              },
                                                              "v-btn",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _c(
                                                              "v-badge",
                                                              {
                                                                attrs: {
                                                                  color:
                                                                    "accent",
                                                                  overlap: "",
                                                                  bordered: "",
                                                                  dot: "",
                                                                  value:
                                                                    _vm.search,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "v-icon",
                                                                  {
                                                                    staticClass:
                                                                      "soli-blue-text text-shadow-blue",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "filter_list"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                false,
                                                1714063686
                                              ),
                                            },
                                            [
                                              _vm._v(" "),
                                              _c(
                                                "v-list",
                                                [
                                                  _c(
                                                    "v-list-item",
                                                    { staticClass: "pl-0" },
                                                    [
                                                      _c("v-text-field", {
                                                        staticClass:
                                                          "pl-6 white pt-0 mt-0",
                                                        attrs: {
                                                          label: "Filter",
                                                          "single-line": "",
                                                          clearable: "",
                                                          "append-icon":
                                                            _vm.search
                                                              ? null
                                                              : "filter_list",
                                                          "hide-details": "",
                                                        },
                                                        model: {
                                                          value: _vm.search,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.search = $$v
                                                          },
                                                          expression: "search",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.$vuetify.breakpoint.smAndUp
                                ? _c(
                                    "v-list-item-action",
                                    [
                                      _c("v-text-field", {
                                        staticClass: "pl-6",
                                        staticStyle: { width: "200px" },
                                        attrs: {
                                          "append-icon": "filter_list",
                                          label: "Filter",
                                          "single-line": "",
                                          "hide-details": "",
                                        },
                                        model: {
                                          value: _vm.search,
                                          callback: function ($$v) {
                                            _vm.search = $$v
                                          },
                                          expression: "search",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("v-data-table", {
                    attrs: {
                      headers: _vm.headers,
                      items: _vm.invoices,
                      "hide-default-footer": "",
                      "disable-pagination": "",
                      "mobile-breakpoint": "0",
                      search: _vm.search,
                    },
                    on: {
                      "click:row": function ($event) {
                        return _vm.$log($event.id)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: `item.user.name`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "d-flex align-center py-2" },
                                [
                                  _c(
                                    "v-list-item-avatar",
                                    {
                                      staticClass: "my-0",
                                      staticStyle: { float: "left" },
                                    },
                                    [
                                      _c("v-img", {
                                        attrs: {
                                          src: item.user.profile_photo_url,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "v-list-item-title",
                                        [
                                          _c(
                                            "Link",
                                            {
                                              attrs: {
                                                href: `/profile/${item.user.id}/account`,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                                        " +
                                                  _vm._s(item.user.name) +
                                                  "\n                                    "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c("v-list-item-subtitle", [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(item.user.email) +
                                            "\n                                "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.paymentMethod`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "font-bold" },
                                [
                                  item.paymentMethod
                                    ? _c(
                                        "v-icon",
                                        { staticClass: "mr-2 soli-blue-text" },
                                        [_vm._v("credit_card")]
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.items`,
                          fn: function ({ item }) {
                            return _vm._l(item.items, function (line, idx) {
                              return _c("div", { key: idx }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(line) +
                                    "\n                        "
                                ),
                              ])
                            })
                          },
                        },
                        {
                          key: `item.discounts`,
                          fn: function ({ item }) {
                            return _vm._l(item.discounts, function (discount) {
                              return _c("div", { key: discount }, [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(discount) +
                                    "\n                        "
                                ),
                              ])
                            })
                          },
                        },
                        {
                          key: `item.total`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "font-bold soli-grey" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(_vm.formatUnitAmount(item.total)) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.last_payment_attempt`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "font-bold soli-grey" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.last_payment_attempt) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.invoice_date`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                { staticClass: "font-bold soli-grey" },
                                [
                                  _vm._v(
                                    "\n                            " +
                                      _vm._s(item.invoice_date) +
                                      "\n                        "
                                  ),
                                ]
                              ),
                            ]
                          },
                        },
                        {
                          key: `item.link`,
                          fn: function ({ item }) {
                            return [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex justify-around transparent",
                                },
                                [
                                  _c(
                                    "v-btn-toggle",
                                    {
                                      staticClass: "transparent soli-round",
                                      model: {
                                        value: _vm.paymentOptions,
                                        callback: function ($$v) {
                                          _vm.paymentOptions = $$v
                                        },
                                        expression: "paymentOptions",
                                      },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "no-link",
                                          attrs: { small: "", color: "white" },
                                          on: {
                                            click: function ($event) {
                                              return _vm.viewInvoice(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "soli-green" } },
                                            [_vm._v("payments")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "no-link",
                                          attrs: {
                                            small: "",
                                            color: "white",
                                            disabled: !item.user.pm_last_four,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.payInvoice(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "secondary" } },
                                            [_vm._v("restore")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "no-link",
                                          attrs: {
                                            disabled:
                                              item.collection_method !==
                                              "send_invoice",
                                            small: "",
                                            color: "white",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.payByCheck(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { color: "dark" } },
                                            [_vm._v("price_check")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      !_vm.showUncollectible
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "no-link",
                                              attrs: {
                                                small: "",
                                                color: "white",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.markUncollectible(
                                                    item
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "v-icon",
                                                { attrs: { color: "error" } },
                                                [_vm._v("block")]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c(
                                        "v-menu",
                                        {
                                          attrs: { left: "", "offset-y": "" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "activator",
                                                fn: function ({ on, attrs }) {
                                                  return [
                                                    _c(
                                                      "v-btn",
                                                      _vm._g(
                                                        _vm._b(
                                                          {
                                                            staticClass:
                                                              "no-link",
                                                            attrs: {
                                                              small: "",
                                                              icon: "",
                                                              color: "white",
                                                            },
                                                            on: {
                                                              click: function (
                                                                $event
                                                              ) {
                                                                _vm.paymentOptions =
                                                                  !_vm.paymentOptions
                                                              },
                                                            },
                                                          },
                                                          "v-btn",
                                                          attrs,
                                                          false
                                                        ),
                                                        on
                                                      ),
                                                      [
                                                        _c(
                                                          "v-icon",
                                                          {
                                                            attrs: {
                                                              color: "dark",
                                                            },
                                                          },
                                                          [_vm._v("more_vert")]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        },
                                        [
                                          _vm._v(" "),
                                          _c(
                                            "v-list",
                                            { attrs: { dense: "" } },
                                            [
                                              _c(
                                                "v-list-item",
                                                {
                                                  staticClass: "no-link",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.viewInvoice(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("View Invoice")]
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-item",
                                                {
                                                  staticClass: "no-link",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.payInvoice(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Retry")]
                                              ),
                                              _vm._v(" "),
                                              item.collection_method ==
                                              "send_invoice"
                                                ? _c(
                                                    "v-list-item",
                                                    {
                                                      staticClass: "no-link",
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.payByCheck(
                                                            item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [_vm._v("Pay By Check")]
                                                  )
                                                : _vm._e(),
                                              _vm._v(" "),
                                              _c(
                                                "v-list-item",
                                                {
                                                  staticClass: "no-link",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.markUncollectible(
                                                        item
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("Mark Uncollectible")]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showMessage
        ? _c("SoliSnack", {
            attrs: {
              text:
                _vm.$page.props.errors.cardDeclined ||
                _vm.$page.props.successMessage,
            },
            on: {
              hide: function ($event) {
                _vm.showMessage = false
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmRetry
        ? _c("SoliChoice", {
            attrs: {
              title: "Are you sure?",
              subtitle: "This invoice was not initially paid by credit card.",
              button1: "Charge credit card",
              button2: "Nevermind",
            },
            on: {
              option1: function ($event) {
                return _vm.payInvoice(_vm.confirmRetry)
              },
              option2: function ($event) {
                return _vm.closeConfirmRetry()
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.confirmUncollectible
        ? _c("SoliChoice", {
            attrs: {
              title: "Are you sure?",
              subtitle:
                "This invoice will still be available in this report, but hidden by default",
              button1: "Mark Uncollectible",
              button2: "Nevermind",
            },
            on: {
              option1: function ($event) {
                return _vm.markUncollectible(_vm.confirmUncollectible)
              },
              option2: function ($event) {
                _vm.closeModal(() => (_vm.confirmUncollectible = false))
              },
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.getCheckNumber
        ? _c("SoliForm", {
            attrs: { title: "Record check number" },
            on: {
              reset: function ($event) {
                return _vm.closeGetCheckNumber()
              },
              submit: function ($event) {
                return _vm.payByCheck(_vm.getCheckNumber)
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "body",
                  fn: function () {
                    return [
                      _c("SoliText", {
                        attrs: {
                          label: "Check #",
                          number: "",
                          "hide-details": "auto",
                          rules: [
                            (val) =>
                              (val || "").length > 0 ||
                              "This field is required",
                          ],
                        },
                        model: {
                          value: _vm.getCheckNumber.checkNumber,
                          callback: function ($$v) {
                            _vm.$set(_vm.getCheckNumber, "checkNumber", $$v)
                          },
                          expression: "getCheckNumber.checkNumber",
                        },
                      }),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              671946547
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }